import styled from 'styled-components';
import { Rect } from 'dragonmouse-shared/geometry';
import { zIndex } from 'tokens';
import { DropShadowMode } from 'dragonmouse-shared/interfaces';

interface DropShadowProps {
	sceneBounds: Rect;
	dropShadowMode: DropShadowMode;
}
export const DropShadow = styled.div<DropShadowProps>`
	position: absolute;
	top: ${(p) => p.sceneBounds.y}px;
	left: ${(p) => p.sceneBounds.x}px;
	width: ${(p) => p.sceneBounds.width}px;
	height: ${(p) => p.sceneBounds.height}px;

	z-index: ${zIndex.ui};

	box-shadow: ${(p) => {
		switch (p.dropShadowMode) {
			case DropShadowMode.NONE:
				return 'none';
			case DropShadowMode.LIGHT:
				return '4px 4px 6px rgba(0, 0, 0, 0.15)';
			case DropShadowMode.MEDIUM:
				return '8px 8px 16px rgba(0, 0, 0, 0.25)';
			case DropShadowMode.HEAVY:
				return '14px 14px 26px rgba(0, 0, 0, 0.35)';
		}
	}};
`;
